// extracted by css-extract-rspack-plugin
export default {"sectionHeading":"sectionHeading-j5pDjz","newReportTypeButton":"newReportTypeButton-nLMVnx"};